import styles from './Sheet.module.scss';
import { Card } from './Card';
import { ItemType, OfferInfoType } from '../App';
import { useAppSelector } from '../Redux/hooks';
import { useOutletContext } from 'react-router';
import { Mode } from '../App';


type Props = {
  mode: Mode
};

type Context = {
  items: ItemType[],
  select: (id: string) => void,
  deleteItem: (id: string) => void,
  makeDiscount: (id: string, newPrice: number) => void,
  offerInfo: OfferInfoType,
};


const Sheet: React.FC<Props> = ({ mode }) => {

  const { items, select, deleteItem, makeDiscount, offerInfo } = useOutletContext<Context>();

  const isLogined = useAppSelector((state) => state.authorization.value);
  const isDicounted = items.find(el => el.finalPrice !== el.startPrice);

  return (
    <div className={`${styles.Sheet} ${isLogined || offerInfo.offerId ? styles.withStatus : ''} ${isDicounted ? styles.withDiscount : ''}`} >
      {/* <div className={`${styles.Sheet} ${styles.withStatus} ${isDicounted ? styles.withDiscount : ''}`} > */}

      {
        [...items].map((item) =>
          <Card
            mode={mode}
            key={item.article_id}
            item={item}
            select={select}
            deleteItem={deleteItem}
            makeDiscount={makeDiscount}
          />)
      }
    </div>
  )
}

export default Sheet